import { parseNumberOfDecimals } from "./parse-helpers.js";
export const toEuro = (value, cents = true, operator = false, removeTrailingZeros = true, maxDecimals = 2) => {
    let euros = value ? value : 0;
    if (cents) {
        euros = value / 100;
    }
    euros = parseFloat(euros.toString());
    const decimals = parseNumberOfDecimals(euros);
    const minAmountOfDecimals = decimals > 0 || !removeTrailingZeros ? 2 : 0;
    let prefix = '';
    if (operator && euros !== 0) {
        prefix = euros > 0 ? '+' : '';
    }
    return prefix + euros.toLocaleString("de-DE", { style: "currency", currency: "EUR", minimumFractionDigits: minAmountOfDecimals, maximumFractionDigits: maxDecimals });
};
//# sourceMappingURL=formatters.js.map